(function () {
    var EventsCtrl = (function () {
        function EventsCtrl() {
            this.init.apply(this, arguments);
        }

        EventsCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $ionicScrollDelegate, $timeout, MKioskService, $message, $q) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;

                this.$element = $("#internal-events-page");
                this.loadData().then(angular.bind(this, function (list) {
                    this.list = list;
                    this.countUnreadEvents = this.getCountUnreadEvents(list);
                }));
                this.counterClicked = -1;
            },
            back: function () {
                this.$state.go("internal.home");
            },
            loadData: function () {
                return this.MKioskService.getEvents();
            },
            getUnreadEvents: function (list) {
                var events = [];
                _.each(list, function (item) {
                    if (item.UnreadComments > 0) {
                        events.push(item);
                    }
                });
                return events;
            },
            getCountUnreadEvents: function (list) {
                return this.getUnreadEvents(list).length;
            },
            onUnreadEventsClicked: function () {
                var list = this.list;
                var countUnreadEvents = this.getCountUnreadEvents(list);
                if (countUnreadEvents === 0)
                    return;

                this.counterClicked++;
                if (this.counterClicked >= countUnreadEvents)
                    this.counterClicked = 0;

                var unreadEvents = this.getUnreadEvents(list),
                    unreadEvent = unreadEvents[this.counterClicked],
                    unreadEventElement = this.$element.find("[event-id='" + unreadEvent.Id + "']"),
                    top = unreadEventElement.position().top;
                this.$ionicScrollDelegate.$getByHandle("events-scroller-handle").scrollTo(0, top, true);
            }
        };
        EventsCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$ionicScrollDelegate', '$timeout', 'MKioskService', '$message', '$q'];
        return EventsCtrl;
    }());
    angular.module('internal.events').controller('EventsCtrl', EventsCtrl)
})();


